module.exports = __webpack_public_path__ + "files/dc902c03091d99021ba46e13c6c883a4.png";